import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import LangSelector from '../UI/LangSelector'
import ConfirmDialog from '../UI/ConfirmDialog'
import tools from '../../tools'
import connexion from '../../connexion'
import french_assets from '../../langs/main.fr.json'
import english_assets from '../../langs/main.en.json'
import german_assets from '../../langs/main.de.json'
import dutch_assets from '../../langs/main.nl.json'
import italian_assets from '../../langs/main.it.json'
import spanish_assets from '../../langs/main.es.json'
import portuguese_assets from '../../langs/main.pt.json'
import TodayOverview from './TodayOverview'
import RecommendedActions from './RecommendedActions'
import OrdersCard from './OrdersCard'
import ActivityWeekCard from './ActivityWeekCard'
import AppEngagementCard from './AppEngagementCard'
import AncillarySalesCard from './AncillarySalesCard'
import TopPagesCard from './TopPagesCard'
import UpcomingBookingsCard from './UpcomingBookingsCard'
import '../Core/Main.css'
import './Home.css'
import {
	ClipboardCheckIcon,
	ClipboardListIcon,
	ChartBarIcon,
	ChevronRightIcon } from '@heroicons/react/outline'
import { fetchOpenTour, fetchPitches } from '../Inventory/Field/fieldApi'
import { stateCounts } from '../Inventory/Field/fieldTours'

const ChatIcon = ({ className }) => (
	<svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
		<path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
	</svg>
)

const DAYS_FR = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']
const MONTHS_FR = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']

class Home extends Component {
	constructor(props) {
		super(props)
		this.lang_assets = {
			fr: french_assets,
			en: english_assets,
			de: german_assets,
			nl: dutch_assets,
			it: italian_assets,
			es: spanish_assets,
			pt: portuguese_assets
		}
		this.state = {
			design: null,
			categories: null,
			pages: null,
			open_modal: false,
			modal_msg: null,
			attempt_submit: false,
			form1: {
				name: '',
				redirect: '{"type":"home"}',
				translations: []
			},
			interventions_stats: null,
			field_tour: null,
			field_pitches: null,
			arrivals: null,
			arrivals_error: false,
			reservations: null,
			reservations_error: false,
			animations: null,
			animation_dates: null,
			benefits: null,
			activities_error: false,
			reviews: null,
			home_stats: null,
			home_stats_error: false,
			current_lang: this.props.lang_default,
			error: this._initErrors(),
			success: null
		}
		this.length_max = 40
		this.content_length = 140
		this.props.updateNavbarTitle('Tableau de bord')
	}

	// Mêmes emplacements que dans le tour : ceux paramétrés et réellement faits (un « non fait » ne compte plus)
	fieldDoneLabel() {
		if (!this.state.field_pitches || !this.state.field_tour)
			return ''
		const counts = stateCounts(this.state.field_pitches, this.state.field_tour)
		const done = this.state.field_pitches.length - counts.todo
		return ', ' + done + (done > 1 ? ' emplacements faits' : ' emplacement fait')
	}

	componentDidMount() {
		// Raccourci Inventaires terrain : tour en cours (gardé sur ce téléphone en attendant le serveur)
		if (this.props.user && this.props.user.permissions && this.props.user.permissions.inventories % 2 === 1)
		{
			fetchOpenTour(this.props.user).then(tour => this.setState({ field_tour: tour })).catch(() => null)
			fetchPitches().then(pitches => this.setState({ field_pitches: pitches })).catch(() => null)
		}
		if (this.props.user && this.props.user.permissions && this.props.user.permissions.interventions % 2 === 1)
		{
			fetch(connexion.connect.url + 'dashboard/interventions/stats')
			.then(res => res.json())
			.then(stats => {
				if (stats !== false)
					this.setState({ interventions_stats: stats })
			})
			.catch(err => console.log("could not fetch interventions stats", err))
		}
		if (this._canSeeMessages())
			this.props.fetchConversations().catch(() => {})
		this.loadPages()
		this.loadArrivals()
		this.loadReservations()
		this.loadBenefits()
		this.loadActivities()
		this.loadReviews()
		this.loadHomeStats()
	}

	loadHomeStats = () => {
		this.setState({ home_stats: null, home_stats_error: false })
		this.props.fetchHomeStats()
		.then(stats => {
			if (stats === false || !stats)
				this.setState({ home_stats_error: true })
			else
				this.setState({ home_stats: stats })
		})
		.catch(err => {
			console.log("could not fetch home stats", err)
			this.setState({ home_stats_error: true })
		})
	}

	_todayBounds = () => {
		const now = new Date()
		const start = Math.round(new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime() / 1000)
		return {
			now: Math.round(now.getTime() / 1000),
			start: start,
			end: start + 86400
		}
	}

	_canSeeOrders = () => {
		const permissions = this.props.user && this.props.user.permissions
		return (this.props.features === "premium" && permissions && permissions.services % 2 === 1)
	}

	_canSeeActivities = () => {
		const permissions = this.props.user && this.props.user.permissions
		return (permissions && permissions.activities % 2 === 1) ? true : false
	}

	_canSeeReviews = () => {
		const permissions = this.props.user && this.props.user.permissions
		return (permissions && permissions.reviews % 2 === 1) ? true : false
	}

	_canSeeMessages = () => {
		const permissions = this.props.user && this.props.user.permissions
		return (permissions && permissions.emails && permissions.emails % 2 === 1) ? true : false
	}

	_unreadMessages = () => {
		const conversations = this.props.conversations || []
		return conversations.filter(c => c.read === false && !c.is_archived && c.status !== 'resolved')
	}

	loadArrivals = () => {
		this.setState({ arrivals: null, arrivals_error: false })
		this.props.fetchArrivals()
		.then(arrivals => {
			this.setState({ arrivals: arrivals })
		})
		.catch(err => {
			console.log("could not fetch arrivals", err)
			this.setState({ arrivals_error: true })
		})
	}

	loadReservations = () => {
		if (!this._canSeeOrders())
		{
			this.setState({ reservations: [] })
			return ;
		}
		this.setState({ reservations: null, reservations_error: false })
		const bounds = this._todayBounds()
		this.props.fetchReservationsByDateRange(bounds.start, bounds.start + 7 * 86400)
		.then(reservations => {
			this.setState({ reservations: reservations })
		})
		.catch(err => {
			console.log("could not fetch reservations", err)
			this.setState({ reservations_error: true })
		})
	}

	loadBenefits = () => {
		if (this.props.features !== "premium")
		{
			this.setState({ benefits: [] })
			return ;
		}
		this.props.fetchServiceBenefits()
		.then(benefits => {
			this.setState({ benefits: benefits || [] })
		})
		.catch(err => {
			console.log("could not fetch service benefits", err)
			this.setState({ benefits: [] })
		})
	}

	loadActivities = () => {
		if (!this._canSeeActivities())
		{
			this.setState({ animations: [], animation_dates: [] })
			return ;
		}
		this.setState({ animations: null, animation_dates: null, activities_error: false })
		Promise.all([
			this.props.fetchAnimations(true),
			this.props.fetchAnimationDates()
		])
		.then(([animations, dates]) => {
			this.setState({
				animations: animations || [],
				animation_dates: dates || []
			})
		})
		.catch(err => {
			console.log("could not fetch activities", err)
			this.setState({ activities_error: true })
		})
	}

	loadReviews = () => {
		if (!this._canSeeReviews())
		{
			this.setState({ reviews: [] })
			return ;
		}
		this.props.fetchReviewsByType("global")
		.then(reviews => {
			this.setState({ reviews: reviews || [] })
		})
		.catch(err => {
			console.log("could not fetch reviews", err)
			this.setState({ reviews: [] })
		})
	}

	_animationName = (animation) => {
		const translations = animation.translations || []
		for (let i = 0; i < translations.length; i++)
		{
			if (translations[i].lang === this.props.lang_default)
				return translations[i].name
		}
		if (translations.length > 0)
			return translations[0].name
		return "Activité"
	}

	_buildWeekActivities = () => {
		if (this.state.animations === null || this.state.animation_dates === null)
			return null
		const animations = this.state.animations
		const dates = this.state.animation_dates
		const benefits = this.state.benefits || []
		const bounds = this._todayBounds()
		const week_end = bounds.now + 7 * 86400
		const animation_by_id = {}
		for (let i = 0; i < animations.length; i++)
			animation_by_id[animations[i]._id] = animations[i]
		const benefit_by_id = {}
		for (let i = 0; i < benefits.length; i++)
			benefit_by_id[benefits[i]._id] = benefits[i]
		const reservations = this.state.reservations || []
		const items = []
		for (let i = 0; i < dates.length; i++)
		{
			const date = dates[i]
			if (date.start < bounds.now || date.start >= week_end)
				continue
			const animation = animation_by_id[date.animation]
			if (!animation)
				continue
			let capacity = null
			let registered = 0
			if (animation.service_benefit && benefit_by_id[animation.service_benefit])
			{
				const benefit = benefit_by_id[animation.service_benefit]
				if (benefit.simultaneous && benefit.simultaneous > 0)
					capacity = benefit.simultaneous
				for (let j = 0; j < reservations.length; j++)
				{
					if (reservations[j].service_benefit === animation.service_benefit
						&& reservations[j].start === date.start
						&& reservations[j].cancelled !== true)
						registered++
				}
			}
			items.push({
				id: date._id,
				title: this._animationName(animation),
				start: date.start,
				registered: registered,
				capacity: capacity
			})
		}
		items.sort((a, b) => {
			return a.start - b.start
		})
		return items
	}

	_computeToday = () => {
		const bounds = this._todayBounds()
		const stays = this.state.arrivals || []
		let arrivals_count = 0
		let precheckins_done = 0
		let onsite_people = 0
		let onsite_stays = 0
		for (let i = 0; i < stays.length; i++)
		{
			const stay = stays[i]
			if (stay.arrival_time >= bounds.start && stay.arrival_time < bounds.end)
			{
				arrivals_count++
				if (stay.precheckin)
					precheckins_done++
			}
			if (stay.arrival_time <= bounds.now && stay.departure_time > bounds.now)
			{
				onsite_stays++
				onsite_people += (stay.nb_people > 0) ? stay.nb_people : 1
			}
		}
		return {
			arrivals: {
				count: arrivals_count,
				precheckinsDone: precheckins_done,
				precheckinsMissing: arrivals_count - precheckins_done
			},
			onsite: {
				people: onsite_people,
				stays: onsite_stays
			}
		}
	}

	_pendingOrders = () => {
		const bounds = this._todayBounds()
		const reservations = this.state.reservations || []
		const pending = []
		let total_today = 0
		for (let i = 0; i < reservations.length; i++)
		{
			const reservation = reservations[i]
			if (reservation.start < bounds.start || reservation.start >= bounds.end)
				continue
			total_today++
			if (reservation.served !== true && reservation.cancelled !== true)
				pending.push(reservation)
		}
		pending.sort((a, b) => {
			return a.start - b.start
		})
		return { pending: pending, totalToday: total_today }
	}

	_newReviewsCount = () => {
		const bounds = this._todayBounds()
		const reviews = this.state.reviews || []
		let count = 0
		for (let i = 0; i < reviews.length; i++)
		{
			if (reviews[i].completed && reviews[i].completed >= bounds.now - 7 * 86400)
				count++
		}
		return count
	}

	_computeActions = (today, orders, week_activities) => {
		const actions = []
		if (today.arrivals.precheckinsMissing > 0)
		{
			actions.push({
				id: 'precheckins',
				priority: 'critical',
				title: (today.arrivals.precheckinsMissing > 1)
					? today.arrivals.precheckinsMissing + " arrivants du jour n'ont pas complété leur pré check-in."
					: "1 arrivant du jour n'a pas complété son pré check-in.",
				detail: "Une relance avant l'arrivée fluidifie l'accueil et le ménage.",
				cta: { label: "Voir les arrivées", to: "/checkins/arrivals" }
			})
		}
		if (orders.pending.length > 0)
		{
			actions.push({
				id: 'orders',
				priority: 'critical',
				title: orders.pending.length + " commande" + ((orders.pending.length > 1) ? "s" : "") + " à préparer aujourd'hui.",
				detail: "Les clients comptent sur leur créneau de retrait.",
				cta: { label: "Voir les commandes", to: "/services/commandes" }
			})
		}
		const new_reviews = this._newReviewsCount()
		if (new_reviews > 0)
		{
			actions.push({
				id: 'reviews',
				priority: 'important',
				title: (new_reviews > 1)
					? new_reviews + " nouveaux avis déposés cette semaine."
					: "1 nouvel avis déposé cette semaine.",
				detail: "Un avis lu rapidement est une occasion de fidéliser.",
				cta: { label: "Consulter les avis", to: "/avis/reponses" }
			})
		}
		if (this._canSeeActivities() && week_activities !== null
			&& week_activities.length === 0 && today.onsite.people > 0)
		{
			actions.push({
				id: 'activities',
				priority: 'important',
				title: "Aucune activité prévue cette semaine.",
				detail: today.onsite.people + " personnes sont sur site : une activité annoncée par notification crée de l'engagement.",
				cta: { label: "Créer une activité", to: "/animations" }
			})
		}
		const unread = this._unreadMessages()
		if (unread.length > 0)
		{
			actions.push({
				id: 'messages',
				priority: 'critical',
				title: unread.length + " message" + ((unread.length > 1) ? "s" : "") + " non lu" + ((unread.length > 1) ? "s" : "") + ".",
				detail: "Des vacanciers attendent votre réponse.",
				cta: { label: "Voir les messages", to: "/messages/chat" }
			})
		}
		return actions
	}

	_benefitNames = () => {
		const names = {}
		const benefits = this.state.benefits || []
		for (let i = 0; i < benefits.length; i++)
		{
			const translations = benefits[i].translations || []
			let name = null
			for (let j = 0; j < translations.length; j++)
			{
				if (translations[j].lang === this.props.lang_default)
				{
					name = translations[j].name || translations[j].title
					break
				}
			}
			if (name === null && translations.length > 0)
				name = translations[0].name || translations[0].title
			if (name)
				names[benefits[i]._id] = name
		}
		return names
	}

	_initErrors = () => {
		return {
			global: null,
			title: null,
			content: null,
			users: null
		}
	}

	setErrorMsg = (key, msg) => {
		if (key === "error_send_notification")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible d'envoyer une notification", msg)
		}
		else if (key === "error_create_notification")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de créer une notification", msg)
		}
		else if (key === "error_update_notification")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de mettre à jour une notification", msg)
		}
		else if (key === "error_delete_notification")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de supprimer une notification", msg)
		}
		else if (key === "error_fetch_notification")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de récupérer les notifications", msg)
		}
		else if (key === "error_fetch_users")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de récupérer les utilisateurs", msg)
		}
		let error = this._initErrors()
		error[key] = msg
		this.setState({ success: null, error: error })
	}

	setSuccessMsg = (msg) => {
		this.clearFlash()
		this.setState({ success: msg, error: this._initErrors() })
	}

	clearFlash = () => {
		this.setState({ success: null, error: this._initErrors() })
	}

	//  = () => {
	// 	this.stats[0].stat = this.state.users
	// }

	handleTitle = (event) => {
		let found = false
		const translations = this.state.form1.translations
		for (let i = 0; i < translations.length; i++)
		{
			if (translations[i].lang === this.state.current_lang)
			{
				found = true
				translations[i].title = event.target.value
				break
			}
		}
		if (!found)
		{
			translations.push({
				lang: this.state.current_lang,
				title: event.target.value,
				content: ''
			})
		}
		const form1 = {
			...this.state.form1,
			translations: translations
		}
		this.setState({ form1: form1 })
	}

	loadPages = () => {
		this.props.fetchPages(true, true)
		.then(pages => {
			this.props.fetchGroups()
			.then(groups => {
				this.props.fetchCategories()
				.then(categories => {
					for (let i = 0; i < categories.length; i++)
					{
						for (let j = 0; j < groups.length; j++)
						{
							if (categories[i].group === groups[j]._id)
							{
								categories[i].group = groups[j]
								break
							}
						}
					}
					this.setState({ categories: categories, pages: pages })
				})
				.catch(err => {
					this.setErrorMsg('error_fetch_notification', 2)
					console.log(err)
				})
			})
			.catch(err => {
				this.setErrorMsg('error_fetch_notification', 3)
				console.log(err)
			})
		})
		.catch(err => {
			this.setErrorMsg('error_fetch_notification', 4)
			console.log(err)
		})
	}

	handleContent = (event) => {
		let found = false
		const translations = this.state.form1.translations
		for (let i = 0; i < translations.length; i++)
		{
			if (translations[i].lang === this.state.current_lang)
			{
				found = true
				translations[i].content = event.target.value
				break
			}
		}
		if (!found)
		{
			translations.push({
				lang: this.state.current_lang,
				title: '',
				content: event.target.value
			})
		}
		const form1 = {
			...this.state.form1,
			translations: translations
		}
		this.setState({ form1: form1 })
	}

	handleRedirect = (event) => {
		const form1 = {
			...this.state.form1,
			redirect: event.target.value
		}
		this.setState({ form1: form1 })
	}

	_validateForm1 = () => {
		const translations = this.state.form1.translations
		let error = false
		let error_obj = this._initErrors()
		let found_default_title = false
		let found_default_content = false
		for (let i = 0; i < translations.length; i++)
		{
			const lang = translations[i].lang
			const title = translations[i].title
			if (title.length === 0 && lang === this.props.lang_default)
			{
				error = true
				error_obj.title = "Vous devez indiquer le titre (version " + lang.toUpperCase() + ")"
			}
			else if (title.length > this.length_max)
			{
				error = true
				error_obj.title = "Le titre ne doit pas dépasser " + this.length_max + " caractères (version " + lang.toUpperCase() + ")"
			}
			else if (lang === this.props.lang_default)
				found_default_title = true
			const content = translations[i].content
			if (content.length === 0 && lang === this.props.lang_default)
			{
				error = true
				error_obj.content = "Vous devez indiquer le contenu (version " + lang.toUpperCase() + ")"
			}
			else if (content.length > this.content_length)
			{
				error = true
				error_obj.content = "Le contenu ne doit pas dépasser " + this.content_length + " caractères (version " + lang.toUpperCase() + ")"
			}
			else if (lang === this.props.lang_default)
				found_default_content = true
		}
		if (!found_default_title && !error_obj.title)
		{
			error = true
			error_obj.title = 'Vous devez indiquer le titre (version ' + this.props.lang_default.toUpperCase() + ')'
		}
		if (!found_default_content && !error_obj.content)
		{
			error = true
			error_obj.content = 'Vous devez indiquer le contenu (version ' + this.props.lang_default.toUpperCase() + ')'
		}
		if (error)
			this.setState({ success: null, error: error_obj, attempt_submit: false })
		return (!error) ? true : false
	}

	handleSend = (event) => {
		event.preventDefault()
		this.clearFlash()
		this.setState({ attempt_submit: true })
		if (this._validateForm1())
		{
			const translations = this.state.form1.translations
			let langs_not_found = []
			for (let i = 0; i < this.props.langs.length; i++)
			{
				let found = false
				for (let j = 0; j < translations.length; j++)
				{
					if (this.props.langs[i] === translations[j].lang && translations[j].title.length > 0)
					{
						found = true
						break
					}
				}
				if (!found)
					langs_not_found.push(this.props.langs[i])
			}
			if (langs_not_found.length > 0)
			{
				let msg = ""
				for (let i = 0; i < langs_not_found.length; i++)
				{
					if (i > 0)
						msg += ', '
					msg += langs_not_found[i].toUpperCase()
				}
				msg = "La notification n'est pas traduite et ne sera pas envoyée dans les langues suivantes : " + msg
				this.setState({ modal_msg: msg, open_modal: true })
			}
			else
				this._sendNotifcation()
		}
	}

	_sendNotifcation = () => {
		const redirect = this.state.form1.redirect
		const translations = this.state.form1.translations
		const notification = {
			user_list: null,
			translations: translations,
			redirect: redirect
		}
		this.props.sendNotifications(notification)
		.then(ret => {
			if (ret === true)
			{
				const form1 = {
					redirect: '{"type":"home"}',
					translations: []
				}
				this.setSuccessMsg("La notification vient d'être envoyée !")
				this.setState({ form1: form1, attempt_submit: false, open_modal: false })
			}
			else
			{
				this.setErrorMsg("global", "Une erreur s'est produite")
				this.setState({ attempt_submit: false, open_modal: false })
			}
		})
		.catch(err => {
			console.log(err)
			this.setErrorMsg("global", "Une erreur s'est produite")
			this.setState({ attempt_submit: false, open_modal: false })
		})
	}

	_getPageList = (categories, pages) => {
		const lang = this.state.current_lang
		let page_list = tools.clone([])
		for (let i = 0; i < categories.length; i++)
		{
			let name = ""
			let suffix = ""
			const category = this.props.categories[i]
			for (let j = 0; j < category.translations.length; j++)
			{
				if (category.translations[j].lang === lang)
				{
					name = category.translations[j].name
					suffix = category.translations[j].suffix
					break
				}
			}
			let prefix = ""
			for (let k = 0; k < this.props.groups.length; k++)
			{
				if (this.props.groups[k]._id === category.group._id)
				{
					const group = this.props.groups[k]
					for (let j = 0; j < group.translations.length; j++)
					{
						if (group.translations[j].lang === lang)
						{
							prefix = group.translations[j].prefix
							break
						}
					}
					break
				}
			}
			let url = this.lang_assets[lang].paths.rubrics + '/' + prefix + '/' + suffix
			if ((prefix.length === 0 || suffix.length === 0) && lang !== this.props.lang_default)
			{
				for (let j = 0; j < category.translations.length; j++)
				{
					if (category.translations[j].lang === this.props.lang_default)
					{
						url = "(rubrique indisponible en version " + lang.toUpperCase() + ")"
						name = category.translations[j].name
						break
					}
				}
			}
			const value = JSON.stringify({
				type: 'category',
				category: categories[i]._id
			})
			for (let k = 0; k < page_list.length; k++)
			{
				if (page_list[k].text === url + ' - ' + name)
				{
					console.log('same category', url + ' - ' + name)
					break
				}
			}
			page_list.push({
				value: value,
				text: name + ' - ' + url
			})
		}
		for (let i = 0; i < pages.length; i++)
		{
			const page = pages[i]
			if (page.category !== null)
				continue
			let name = ""
			let url = this.lang_assets[lang].paths.pages + '/'
			for (let j = 0; j < page.translations.length; j++)
			{
				if (page.translations[j].lang === lang)
				{
					name = page.translations[j].name
					url += page.translations[j].url
					break
				}
			}
			if (name.length === 0 && lang !== this.props.lang_default)
			{
				for (let j = 0; j < page.translations.length; j++)
				{
					if (page.translations[j].lang === this.props.lang_default)
					{
						url = "(page indisponible en version " + lang.toUpperCase() + ")"
						name = page.translations[j].name
						break
					}
				}
			}
			for (let k = 0; k < page_list.length; k++)
			{
				if (page_list[k].text === url + ' - ' + name)
				{
					console.log('same page', url + ' - ' + name)
					break
				}
			}
			const value = JSON.stringify({
				type: 'page',
				page: page._id
			})
			page_list.push({
				value: value,
				text: name + ' - ' + url
			})
		}
		page_list.sort((a, b) => {
			return a.text.localeCompare(b.text)
		})
		page_list.unshift({
			value: JSON.stringify({
				type: 'membres'
			}),
			text: "Page membres - " + this.lang_assets[lang].paths.account
		})
		page_list.unshift({
			value: JSON.stringify({
				type: 'animations'
			}),
			text: "Planning d'animations -" + this.lang_assets[lang].paths.activities
		})
		page_list.unshift({
			value: JSON.stringify({
				type: 'home'
			}),
			text: "Page d'accueil - /"
		})
		return (
			<select
				id="redirect"
				className="browser-default block w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-sm font-semibold text-slate-800 focus:border-indigo-500 focus:outline-none shadow-sm transition-all cursor-pointer"
				value={this.state.form1.redirect}
				onChange={this.handleRedirect}
			>
				{page_list.map(({ value, text }) => {
					return (<option value={value} key={value}>{text}</option>)
				})}
			</select>
		)
	}

	answerModal = (answer) => {
		if (answer === "yes")
		{
			this.setState({ open_modal: false })
			this._sendNotifcation()
		}
		else
			this.setState({ attempt_submit: false, open_modal: false })
	}

	updateLang = (lang) => {
		this.setState({ current_lang: lang })
	}

	classNames = (...classes) => {
		return classes.filter(Boolean).join(' ')
	}

	render() {
		const categories = this.state.categories
		const pages = this.state.pages
		const permissions = this.props.user.permissions
		if (!permissions || !permissions.homepage || permissions.homepage === 0)
		{
			let redirection = null
			if (permissions && permissions.rubrics % 2 === 1)
				redirection = "/rubriques"
			else if (permissions && permissions.activities % 2 === 1)
				redirection = "/animations"
			else if (permissions && permissions.services % 2 === 1)
				redirection = "/services"
			else if (permissions && permissions.users % 2 === 1)
				redirection = "/utilisateurs"
			else if (permissions && permissions.reviews % 2 === 1)
				redirection = "/avis/reponses"
			else if (permissions && permissions.stats % 2 === 1)
				redirection = "/stats"
			else if (permissions && permissions.emails % 2 === 1)
				redirection = "/administration/emails"
			else if (permissions && permissions.inventories % 2 === 1)
				redirection = "/inventaires/checkin"
			else if (permissions && permissions.deposits % 2 === 1)
				redirection = "/deposit/users-deposit"
			else if (permissions && permissions.notifications % 2 === 1)
				redirection = "/administration/notifications"
			else if (permissions && permissions.interventions % 2 === 1)
				redirection = "/interventions"
			else if (permissions && permissions.params % 2 === 1)
				redirection = "/administration/parametres"
			if (redirection != null)
				return (<Redirect to={redirection} />)
		}
		else
		{
			let printMsg = null
			if (this.state.error.global || this.state.success)
			{
				printMsg = (
					<div className="center">
						<p className="error">{this.state.error.global}</p>
						<p className="success">{this.state.success}</p>
					</div>
				)
			}
			let sendbtn = (
				<button
					type="submit"
					className="w-full inline-flex justify-center items-center px-5 py-3 mt-1 text-2xs font-black uppercase tracking-widest rounded-xl shadow-sm text-white cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
					style={{ backgroundImage: 'none', backgroundColor: '#4f46e5' }}
					onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#4338ca' }}
					onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#4f46e5' }}
				>
					Envoyer la notification
				</button>
			)
			if (this.state.attempt_submit === true)
			{
				sendbtn = (
					<button
						type="submit"
						disabled
						className="w-full inline-flex justify-center items-center px-5 py-3 mt-1 text-2xs font-black uppercase tracking-widest rounded-xl shadow-sm text-white opacity-80 cursor-not-allowed transition-all focus:outline-none"
						style={{ backgroundImage: 'none', backgroundColor: '#4f46e5' }}
					>
						<svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
							<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
							<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
						</svg>
						Envoi en cours…
					</button>
				)
			}
			let title = ""
			let content = ""
			for (let i = 0; i < this.state.form1.translations.length; i++)
			{
				if (this.state.form1.translations[i].lang === this.state.current_lang)
				{
					title = this.state.form1.translations[i].title
					content = this.state.form1.translations[i].content
					break
				}
			}
			const page_dropdown = (pages && categories) ? this._getPageList(categories, pages) : null
			const today = this._computeToday()
			const orders = this._pendingOrders()
			const week_activities = this._buildWeekActivities()
			const arrivals_loading = (this.state.arrivals === null && this.state.arrivals_error === false)
			const home_stats = this.state.home_stats
			const home_stats_loading = (home_stats === null && this.state.home_stats_error === false)
			const engagement = (home_stats && home_stats.engagement) ? home_stats.engagement : {}
			const sales = (home_stats && home_stats.sales) ? home_stats.sales : {}
			const new_reviews = this._newReviewsCount()
			const interventions_todo = (this.state.interventions_stats) ? this.state.interventions_stats.todo : 0
			const unread_messages = this._unreadMessages()
			const unread_count = unread_messages.length
			const can_see_messages = this._canSeeMessages()
			const todo_parts = []
			if (orders.pending.length > 0)
				todo_parts.push(orders.pending.length + ' commande' + ((orders.pending.length > 1) ? 's' : ''))
			if (unread_count > 0)
				todo_parts.push(unread_count + ' message' + ((unread_count > 1) ? 's' : ''))
			if (new_reviews > 0)
				todo_parts.push(new_reviews + ' avis')
			if (interventions_todo > 0)
				todo_parts.push(interventions_todo + ' intervention' + ((interventions_todo > 1) ? 's' : ''))
			let todo_link = null
			if (orders.pending.length > 0)
				todo_link = '/services/commandes'
			else if (unread_count > 0)
				todo_link = '/messages/chat'
			else if (new_reviews > 0)
				todo_link = '/avis/reponses'
			else if (interventions_todo > 0)
				todo_link = '/interventions'
			const todo = {
				total: orders.pending.length + unread_count + new_reviews + interventions_todo,
				detail: todo_parts.join(' · '),
				to: todo_link
			}
			const can_see_interventions = (this.props.user && this.props.user.permissions && this.props.user.permissions.interventions % 2 === 1) ? true : false
			const show_todo = this._canSeeOrders() || this._canSeeReviews() || can_see_interventions || can_see_messages
			const now_date = new Date()
			const date_label = DAYS_FR[now_date.getDay()] + ' ' + now_date.getDate() + ' ' + MONTHS_FR[now_date.getMonth()] + ' ' + now_date.getFullYear()
			const cta_classes = "inline-flex items-center px-5 py-3 text-2xs font-black uppercase tracking-widest rounded-xl shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
			const cta_style = { backgroundImage: 'none' }
			let header_cta = can_see_interventions
				? (<Link to="/interventions" className={cta_classes} style={cta_style}>Voir les interventions</Link>)
				: (<a href="#notification" className={cta_classes} style={cta_style}>Envoyer une notification</a>)
			if (this._canSeeOrders() && orders.pending.length > 0)
				header_cta = (<Link to="/services/commandes" className={cta_classes} style={cta_style}>Traiter les {orders.pending.length} commande{(orders.pending.length > 1) ? 's' : ''}</Link>)
			else if (today.arrivals.count > 0)
				header_cta = (<Link to="/checkins/arrivals" className={cta_classes} style={cta_style}>Voir les {today.arrivals.count} arrivée{(today.arrivals.count > 1) ? 's' : ''}</Link>)
			return (
				<div className="wrapper-content Home">
					<ConfirmDialog
						open={this.state.open_modal}
						title="Traductions manquantes"
						message={this.state.modal_msg}
						confirmLabel="Envoyer quand même"
						cancelLabel="Annuler"
						onConfirm={() => this.answerModal("yes")}
						onCancel={() => this.answerModal("no")}
					/>
					<div className="flex flex-wrap items-end justify-between gap-4 mb-6">
						<div>
							<p className="text-2xs font-black text-slate-400 uppercase tracking-widest my-0 mb-1">{date_label}</p>
							<h1 className="text-3xl font-black text-slate-900 my-0 leading-none">Votre journée</h1>
						</div>
						{header_cta}
					</div>
					{this.state.arrivals_error === true &&
						<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5">
							<p className="text-sm font-medium text-slate-500 mt-0 mb-3">Les arrivées et présences ne peuvent pas être affichées pour le moment.</p>
							<button
								type="button"
								onClick={this.loadArrivals}
								className="inline-flex items-center px-4 py-2 text-2xs font-black uppercase tracking-widest rounded-xl text-indigo-700 cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
								style={{ backgroundImage: 'none', backgroundColor: '#eef2ff' }}
							>
								Réessayer
							</button>
						</div>
					}
					{this.state.arrivals_error === false &&
						<TodayOverview
							loading={arrivals_loading}
							arrivals={today.arrivals}
							onsite={today.onsite}
							todo={todo}
							showTodo={show_todo}
						/>
					}
					<div className="mt-5">
						<RecommendedActions
							loading={arrivals_loading}
							actions={this._computeActions(today, orders, week_activities)}
						/>
					</div>
					{this.props.user && this.props.user.permissions && this.props.user.permissions.interventions % 2 === 1 && this.state.interventions_stats !== null && (
						<div className="mt-5 bg-white border border-slate-200 rounded-2xl shadow-sm p-5 flex flex-wrap items-center justify-between gap-3">
							<div className="flex items-center gap-3">
								<div className="w-9 h-9 rounded-xl bg-emerald-50 flex items-center justify-center flex-shrink-0">
									<ClipboardCheckIcon className="w-5 h-5 text-emerald-600" aria-hidden="true" />
								</div>
								<div>
									<p className="text-2xs font-bold text-slate-400 uppercase tracking-widest my-0">Interventions en cours</p>
									<p className="text-2xl font-black text-slate-900 my-0 leading-tight">
										{this.state.interventions_stats.todo} <span className="text-sm font-bold text-slate-400">à traiter</span>
										{this.state.interventions_stats.urgent > 0 && <span className="ml-2 text-3xs font-black uppercase tracking-wider px-2 py-0.5 rounded-full bg-rose-100 text-rose-700 align-middle">{this.state.interventions_stats.urgent} urgente{this.state.interventions_stats.urgent > 1 ? 's' : ''}</span>}
									</p>
								</div>
							</div>
							<Link
								to="/interventions"
								className="inline-flex items-center px-5 py-3 text-2xs font-black uppercase tracking-widest rounded-xl shadow-sm text-white bg-emerald-600 hover:bg-emerald-700 cursor-pointer transition-all active:scale-95"
								style={{ backgroundImage: 'none' }}
							>
								Voir les interventions
							</Link>
						</div>
					)}
					{/* Raccourci vers les inventaires terrain, surtout pour le téléphone (demande d'Alexandra du 25/10/2026) */}
					{this.props.user && this.props.user.permissions && this.props.user.permissions.inventories % 2 === 1 && (
						<div className="mt-5 bg-white border border-slate-200 rounded-2xl shadow-sm p-5 flex flex-wrap items-center justify-between gap-3">
							<div className="flex items-center gap-3">
								<div className="w-9 h-9 rounded-xl bg-amber-50 flex items-center justify-center flex-shrink-0">
									<ClipboardListIcon className="w-5 h-5 text-amber-600" aria-hidden="true" />
								</div>
								<div>
									<p className="text-2xs font-bold text-slate-400 uppercase tracking-widest my-0">Inventaires terrain</p>
									<p className="text-base font-bold text-slate-900 my-0 leading-tight">
										{this.state.field_tour ? this.state.field_tour.name + this.fieldDoneLabel() : 'Entrée, sortie, hors séjour ou tour de terrain'}
									</p>
								</div>
							</div>
							<div className="flex flex-wrap gap-2 w-full sm:w-auto">
								<Link
									to="/inventaires-terrain"
									className="flex-1 sm:flex-none inline-flex items-center justify-center px-5 py-3 text-2xs font-black uppercase tracking-widest rounded-xl shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 cursor-pointer transition-all active:scale-95"
									style={{ backgroundImage: 'none' }}
								>
									Faire un inventaire
								</Link>
								<Link
									to="/inventaires-terrain?ouvrir=tour"
									className="flex-1 sm:flex-none inline-flex items-center justify-center px-5 py-3 text-2xs font-black uppercase tracking-widest rounded-xl shadow-sm text-slate-900 cursor-pointer transition-all active:scale-95"
									style={{ backgroundImage: 'none', backgroundColor: '#FFB82E' }}
								>
									{this.state.field_tour ? 'Reprendre le tour' : 'Démarrer un tour'}
								</Link>
							</div>
						</div>
					)}
					{can_see_messages && unread_count > 0 && (
						<div className="mt-5 bg-white border border-slate-200 rounded-2xl shadow-sm p-5 flex flex-wrap items-center justify-between gap-3">
							<div className="flex items-center gap-3">
								<div className="w-9 h-9 rounded-xl bg-indigo-50 flex items-center justify-center flex-shrink-0">
									<ChatIcon className="w-5 h-5 text-indigo-600" aria-hidden="true" />
								</div>
								<div>
									<p className="text-2xs font-bold text-slate-400 uppercase tracking-widest" style={{ margin: 0 }}>Messages non lus</p>
									<p className="text-2xl font-black text-slate-900 leading-tight" style={{ margin: 0 }}>
										{unread_count} <span className="text-sm font-bold text-slate-400">à lire</span>
									</p>
								</div>
							</div>
							<Link
								to="/messages/chat"
								className="inline-flex items-center px-5 py-3 text-2xs font-black uppercase tracking-widest rounded-xl shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 cursor-pointer transition-all active:scale-95"
								style={{ backgroundImage: 'none' }}
							>
								Voir les messages
							</Link>
						</div>
					)}
					<div className="mt-5 grid grid-cols-1 lg:grid-cols-3 gap-4 items-start">
						<div className="lg:col-span-2 space-y-4">
							{this._canSeeOrders() &&
								<OrdersCard
									loading={this.state.reservations === null && this.state.reservations_error === false}
									error={this.state.reservations_error}
									onRetry={this.loadReservations}
									pending={orders.pending}
									totalToday={orders.totalToday}
									benefitNames={this._benefitNames()}
									langDefault={this.props.lang_default}
								/>
							}
							{this._canSeeOrders() &&
								<UpcomingBookingsCard
									loading={this.state.reservations === null && this.state.reservations_error === false}
									error={this.state.reservations_error}
									onRetry={this.loadReservations}
									reservations={this.state.reservations || []}
									benefits={this.state.benefits || []}
									langDefault={this.props.lang_default}
								/>
							}
							{this._canSeeOrders() &&
								<AncillarySalesCard
									loading={home_stats_loading}
									error={this.state.home_stats_error}
									onRetry={this.loadHomeStats}
									revenue7d={sales.revenue7d}
									avgCart={sales.avgCart}
									topProduct={sales.topProduct}
								/>
							}
							{this._canSeeActivities() &&
								<ActivityWeekCard
									loading={week_activities === null && this.state.activities_error === false}
									error={this.state.activities_error}
									onRetry={this.loadActivities}
									items={week_activities || []}
									onsitePeople={today.onsite.people}
									premium={this.props.features === "premium"}
									views7d={engagement.activityViews7d}
									viewsDeltaPct={engagement.activityDeltaPct}
								/>
							}
						</div>
						<div className="space-y-4">
							<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5" id="notification">
								<div className="flex items-center justify-between mb-4">
									<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest mt-0 mb-0">Envoyer une notification</h2>
									<Link to="/administration/notifications" className="group flex items-center gap-1 text-2xs font-black uppercase tracking-widest text-indigo-600 hover:text-indigo-800 transition-colors whitespace-nowrap">
										Notifications
										<ChevronRightIcon className="w-4 h-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
									</Link>
								</div>
							{(!pages || !categories) &&
								<div className="animate-pulse space-y-4">
									<div className="flex gap-1.5">
										{[1, 2, 3, 4, 5, 6, 7].map(key => (
											<div key={key} className="w-9 h-9 bg-slate-100 rounded-xl"></div>
										))}
									</div>
									<div>
										<div className="h-3 bg-slate-200 rounded-full w-24 mb-2"></div>
										<div className="h-11 bg-slate-100 rounded-xl"></div>
									</div>
									<div>
										<div className="h-3 bg-slate-200 rounded-full w-28 mb-2"></div>
										<div className="h-11 bg-slate-100 rounded-xl"></div>
									</div>
									<div className="h-11 bg-slate-200 rounded-xl"></div>
								</div>
							}
							{pages && categories &&
							<>
							{printMsg}
							<span className="block text-2xs font-bold text-slate-400 uppercase tracking-widest mb-1.5">Langue d'édition</span>
							<LangSelector variant="card" lang={this.state.current_lang} updateLang={this.updateLang} />
							<form className="space-y-4 mt-4" onSubmit={this.handleSend}>
								<label className="block">
									{this.state.error.title &&
										<p className="error text-xs font-bold mt-0 mb-1">{this.state.error.title}</p>
									}
									<span className="block text-2xs font-bold text-slate-400 uppercase tracking-widest mb-1.5">Titre (version {this.state.current_lang.toUpperCase()})</span>
									<input
										type="text"
										className="browser-default block w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-sm font-semibold text-slate-800 placeholder-slate-400 focus:border-indigo-500 focus:outline-none shadow-sm transition-all"
										value={title}
										onChange={this.handleTitle}
									/>
								</label>
								<label className="block">
									{this.state.error.content &&
										<p className="error text-xs font-bold mt-0 mb-1">{this.state.error.content}</p>
									}
									<span className="block text-2xs font-bold text-slate-400 uppercase tracking-widest mb-1.5">Contenu (version {this.state.current_lang.toUpperCase()})</span>
									<input
										type="text"
										className="browser-default block w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-sm font-semibold text-slate-800 placeholder-slate-400 focus:border-indigo-500 focus:outline-none shadow-sm transition-all"
										value={content}
										onChange={this.handleContent}
									/>
								</label>
								<label className="block">
									<span className="block text-2xs font-bold text-slate-400 uppercase tracking-widest mb-1.5">Page ouverte par la notification</span>
									{page_dropdown}
								</label>
								{sendbtn}
							</form>
							</>
							}
							</div>
							<AppEngagementCard
								loading={home_stats_loading}
								error={this.state.home_stats_error}
								onRetry={this.loadHomeStats}
								visitors7d={engagement.visitors7d}
								deltaPct={engagement.deltaPct}
								daily={engagement.daily}
								installs={engagement.installs}
								topPages={engagement.topPages}
							/>
							<Link
								to="/stats"
								className="group flex items-center gap-3 bg-white border border-slate-200 rounded-2xl shadow-sm p-4 cursor-pointer transition-all hover:shadow-md hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-indigo-500"
							>
								<div className="w-9 h-9 rounded-xl bg-sky-50 flex items-center justify-center flex-shrink-0">
									<ChartBarIcon className="w-5 h-5 text-sky-600" aria-hidden="true" />
								</div>
								<div className="flex-1 min-w-0">
									<p className="text-sm font-bold text-slate-800 my-0">Statistiques générales</p>
									<p className="text-xs font-medium text-slate-400 my-0 mt-0.5 truncate">Visiteurs, pages vues, téléchargements</p>
								</div>
								<ChevronRightIcon className="w-4 h-4 text-slate-300 transition-transform group-hover:translate-x-0.5 flex-shrink-0" aria-hidden="true" />
							</Link>
							<TopPagesCard
								loading={home_stats_loading}
								error={this.state.home_stats_error}
								onRetry={this.loadHomeStats}
								pages={engagement.topPages}
								period={engagement.topPagesPeriod}
							/>
						</div>
					</div>
				</div>
			)
			/*let service = null
			let animations = null
			let like = null
			return (
				<div className="wrapper-content">
					<div className="row">
						<div className="module col s6">
							<h2>Administration générale</h2>
							<p>Voici les différentes actions que vous pouvez effectuer :</p>
							<ul>
								<li><Link to="/modules">Administrer la page d'accueil</Link></li>
								<li><Link to="/administration/parametres">Paramètres généraux</Link></li>
								<li><Link to="/administration/emails">Paramétrer les envoi d'email</Link></li>
								<li><Link to="/themes">Gérer les thèmes</Link></li>
								<li><Link to="/icons">Administrer les icônes</Link></li>
								<li><Link to="/menu">Administrer le menu</Link></li>
							</ul>
						</div>
						<div className="module col s6">
							<h2 className="title-description">Accès rapide</h2>
							<p className="overview">
								<img className="icon" src={file} alt="Pages" /> <span className="text">Créer une page</span>
							</p>
							<p className="overview">
								<img className="icon" src={service} alt="Services" /> <span className="text">Ajouter un service</span>
							</p>
							<p className="overview">
								<img className="icon" src={animations} alt="Animations" /> <span className="text">Ajouter une animation</span>
							</p>
							<p className="overview">
								<img className="icon" src={like} alt="Partenaires" /> <span className="text">Changer de thème</span>
							</p>
						</div>
						<div className="module col s6">
							<h2 className="title-description">Top des pages les plus consultées</h2>
							<p className="top-five">
								<strong>1</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Animations<br />
								<strong>2</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Location de vélos<br />
								<strong>3</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Spa<br />
								<strong>4</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Informations pratiques<br />
								<strong>5</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Location de kayaks<br />
							</p>
						</div>
					</div>
				</div>
			)*/
		}
	}
}

export default Home
